import React, { createContext, useContext, type ComponentType } from 'react';
type SlideIndex = {
  index: number;
  total: number;
};
const SlideIndexContext = createContext<SlideIndex | null>(null);

/** Page number + deck length for the slide currently rendering. */
export function useSlideIndex(): SlideIndex | null {
  return useContext(SlideIndexContext);
}

/** Wraps a slide so its footer page number follows its position in the deck. */
export function withSlideIndex(Component: ComponentType, index: number, total: number): ComponentType {
  function IndexedSlide() {
    return <SlideIndexContext.Provider value={{
      index,
      total
    }} data-id="element-35" data-mp="j0fdj32ucthf">
        <Component data-id="element-36" data-mp="j0xhymznqe0f" />
      </SlideIndexContext.Provider>;
  }
  IndexedSlide.displayName = `Indexed(${Component.displayName ?? Component.name ?? 'Slide'})`;
  return IndexedSlide;
}